import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { MdIcons, Modal } from '@kiper/ui';
import { ButtonSubmit } from '../../styles';
import { IconBadge, LostAccessBody, LostAccessText } from '../styles';

const LostAccessModal = ({ open, toggle, onBackToLogin }) => {
  const [t] = useTranslation('login');

  return (
    <Modal
      open={open}
      toggle={toggle}
      size="sm"
      title={t('two-step.lost-access')}
    >
      <LostAccessBody>
        <IconBadge>
          <MdIcons mdIconName="support_agent" size="24px" color="primary500" />
        </IconBadge>
        <LostAccessText>{t('two-step.lost-access-description')}</LostAccessText>
        <ButtonSubmit
          block
          color="primary"
          type="button"
          onClick={onBackToLogin}
        >
          {t('back-to-login')}
        </ButtonSubmit>
      </LostAccessBody>
    </Modal>
  );
};

export default LostAccessModal;

LostAccessModal.propTypes = {
  open: propTypes.bool.isRequired,
  toggle: propTypes.func.isRequired,
  onBackToLogin: propTypes.func.isRequired,
};
